import { createSlice } from "@reduxjs/toolkit";
import { addStationDevicesAPI } from "../../actions/stations/addStationDevice";

const initialState = {
  stationDevice: {},
  loading: false,
  error: { code: "", message: "" },
};

const addStationDeviceSlice = createSlice({
  name: "addStationDevice",
  initialState,
  reducers: {
    resetUserData: (state) => {
      state = initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addStationDevicesAPI.pending, (state) => {
        state.loading = true;
      })
      .addCase(addStationDevicesAPI.fulfilled, (state, action) => {
        state.stationDevice = action.payload.data;
        state.loading = false;
      })
      .addCase(addStationDevicesAPI.rejected, (state, action) => {
        state.error = action.payload.error;
        state.loading = false;
      });
  },
});

export const { resetUserData } = addStationDeviceSlice.actions;
export default addStationDeviceSlice.reducer;
